// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2hGGG","footer":"ReportModalFilter_footer__UnUW3"};